module.exports = __webpack_public_path__ + "img/astral_6.749d61fc.svg";